'use client';
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { VideoTypeEnum } from '@/lib/types/api/video';
import PlayIcon from '@/public/svg/play.svg';

import styles from './WatchVideoButton.module.scss';

interface WatchVideoButtonProps {
  videoType: VideoTypeEnum;
  onClick: (() => void) | null;
  className?: string;
  verticalOffset: boolean;
  customButtonText?: string; // Override the default video type-based text
}

const WatchVideoButton = (props: WatchVideoButtonProps) => {
  const {
    videoType,
    onClick,
    className,
    verticalOffset,
    customButtonText,
  } = props;

  let videoTypeString = 'Video';

  if (customButtonText) {
    videoTypeString = customButtonText;
  } else {
    switch (videoType) {
      case 'preview':
        videoTypeString = 'Preview';
        break;
      case 'episode':
        videoTypeString = 'Episode';
        break;
      case 'special':
        videoTypeString = 'Special';
        break;
      case 'clip':
        videoTypeString = 'Clip';
        break;
      case 'live':
        videoTypeString = 'Live';
        break;
    }
  }

  let classNames = `${styles.watch_video_button}`;

  if (className) {
    classNames += ` ${className}`;
  }

  if (verticalOffset) {
    classNames += ` ${styles.vertical_offset}`;
  }

  if (onClick) {
    return (
      <button
        onClick={() => onClick()}
        className={classNames}
        >
        <div className={styles.watch_video_button_icon}>
          <PlayIcon />
        </div>
        <span className={styles.watch_video_button_text}>
          Watch {videoTypeString}
        </span>
      </button>
    );
  } else if (onClick === null) {
    return (
        <div
          className={classNames}
          >
          <div className={styles.watch_video_button_icon}>
            <PlayIcon />
          </div>
          <span className={styles.watch_video_button_text}>
            Watch {videoTypeString}
          </span>
        </div>
      );
  }
}

export default WatchVideoButton;
